module.exports = __webpack_public_path__ + "images/jet-setter-7f7a29f4a19c5aa8476be21163c21af8.png";